<template>

  <body class="dx-viewport">
    <DxDataGrid ref="dataGridPeUserRef" :allowColumnReordering="true" :data-source="dsTargetPeUser"
      :allowColumnResizing="true" key-expr="ID" :columnAutoWidth="false" :columnMinWidth="50"
      :columnResizingMode="'nextColumn'" :show-borders="true" :syncLookupFilterValues="false"
      :filter-sync-enabled="true" :show-row-lines="true" :show-column-lines="true" @row-inserting="onRowInserting"
      @row-removing="onRowRemoving" class="border">
      <DxSelection mode="single" />
      <DxFilterRow :visible="true" />
      <DxPaging :page-size="5" :page-index="1" />
      <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
      <DxSorting mode="multiple" />
      <DxStateStoring :enabled="true" :filterValue="false" storage-key="TargetPeUser" />
      <DxToolbar>
        <DxItem>
          <template #default>
            <DxButton icon="add" type="success" @click="onAddClick" />
          </template>
        </DxItem>
        <DxItem>
          <template #default>
            <DxButton icon="refresh" @click="onRefreshClick" />
          </template>
        </DxItem>
      </DxToolbar>
      <DxEditing :allowUpdating="true" :allowDeleting="true" mode="popup" @click="onRowRemoving">
        <DxPopup :closeOnOutsideClick="false" :showCloseButton="false" :width="500" :height="200">
          <DxToolbarItem :template="customTitleTemplate" />
          <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="successButtonOptions" />
          <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="dangerButtonOptions" />
        </DxPopup>
        <DxFormGrid>
          <DxItem :col-span="1" :col-count="1" item-type="group">
            <DxItem data-field="Target" :editor-options="{ width: 450 }" />
            <DxItem dataField="TargetID" :colSpan="1" :isRequired="false" :editorOptions="{
              dataSource: dsTarget,
              displayExpr: 'Nume',
              valueExpr: 'ID',
              width: 250
            }" :visible="false" />
          </DxItem>
        </DxFormGrid>
      </DxEditing>
      <DxColumn dataField="ID" :visible="false" />
      <DxColumn data-field="Utilizator" />
      <DxColumn data-field="Target" />
      <DxColumn data-field="TargetID" :visible="false" />
    </DxDataGrid>
    <DxPopupAdd :visible.sync="isModalVisible" :closeOnOutsideClick="false" :showCloseButton="false" :showTitle="true"
      :width="500" :height="290">
      <template #title>
        <div
          style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold;  padding: 10px; padding-left: 20px; ">
          Adăugare</div>
      </template>
      <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="addSaveButtonOptions" />
      <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="addCancelButtonOptions" />
      <div>
        <DxForm :formData="formData">
          <DxItem :col-span="1" :col-count="1" item-type="group">
            <DxItem dataField="TargetID" :colSpan="1" :isRequired="true" :visible="false" :editorOptions="{
              dataSource: dsTarget,
              valueExpr: 'TargetID',
              width: 270
            }" :label="{ text: 'Target' }" />
            <DxItem dataField="Utilizator" :isRequired="true">
              <DxSelectBox :dataSource="dsAgenti" display-expr="Nume" value-expr="Nume" :search-enabled="true"
                v-model="formData.Utilizator"></DxSelectBox>
            </DxItem>
            <DxItem dataField="Target" :isRequired="true" :editor-options="{ width: 450 }" editorType="dxNumberBox"
              :validation-rules="[{ type: 'numeric', message: 'Câmpul trebuie să conțină doar numere.' }]" />
          </DxItem>
        </DxForm>
      </div>
    </DxPopupAdd>
  </body>
</template>

<script lang="ts">
import { defineComponent, readonly, ref } from 'vue';
import { DxButton } from 'devextreme-vue/button';
import DxPopupAdd, { DxToolbarItem } from 'devextreme-vue/popup';
import { DxItem, DxForm, DxLabel } from 'devextreme-vue/form';
import { DxSelectBox } from 'devextreme-vue/select-box'
import { DxTextBox } from 'devextreme-vue/text-box'
import {
  DxColumn,
  DxDataGrid,
  DxFilterRow,
  DxLoadPanel,
  DxPaging,
  DxSelection,
  DxSorting,
  DxStateStoring,
  DxToolbar,
  DxEditing,
  DxPopup,
  DxItem as DxItemForm,
  DxForm as DxFormGrid,
  DxValidationRule,
  DxRequiredRule,
} from 'devextreme-vue/data-grid';
import 'devextreme/dist/css/dx.light.css';
import 'devextreme/dist/css/dx.common.css';
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '@/settings/appSettings';
import CrmNomenclatoare from '@/services/Comercial/CrmNomenclatoare';
import CrmTargetPeUser from '@/services/Comercial/CrmTargetPeUser';
import notify from 'devextreme/ui/notify';
import { locale, loadMessages } from 'devextreme/localization';
import { watch, onMounted } from 'vue';
import { dataSource } from 'devexpress-reporting/scopes/reporting-designer-controls-metadata';


export default defineComponent({
  components: {
    DxToolbar,
    DxDataGrid,
    DxColumn,
    DxSorting,
    DxSelection,
    DxFilterRow,
    DxStateStoring,
    DxLoadPanel,
    DxPaging,
    DxButton,
    DxItem,
    DxPopup,
    DxForm,
    DxLabel,
    DxEditing,
    DxPopupAdd,
    DxToolbarItem,
    DxItemForm,
    DxFormGrid,
    DxValidationRule,
    DxRequiredRule,
    DxSelectBox,
    DxTextBox,
  },
  props: {
    TargetID: String
  },
  data() {
    return {
      target: [
        { ID: 1, TargetID: 1, Utilizator: 'Gina_Calugarita', Target: '800000' },
        { ID: 2, TargetID: 2, Utilizator: 'Damian_Denes', Target: '109250' },
        // Add more contacts
      ],
      agenti: [],
      dsTargetPeUser: {} as ODataStore,
      dsTarget: {} as ODataStore,
      dsAgenti: {} as ODataStore,
      isModalVisible: false,
      formData: {
        TargetID: '',
        Utilizator: '',
        Target: '',
      },
      deleteConfirmationMessage: "Sigur doriți să ștergeți această înregistrare?",

      dataGridPeUserRef: ref<DxDataGrid | null>(null),
      successButtonOptions: {
        type: 'success',
        stylingMode: 'contained',
        text: 'Salvează',
        onClick: () => {
          this.onSaveEdit();
        },
      },
      dangerButtonOptions: {
        type: 'danger',
        stylingMode: 'contained',
        text: 'Închide',
        onClick: () => {
          this.onCancelEdit();
        },
      },
      addSaveButtonOptions: {
        type: 'success',
        stylingMode: 'contained',
        text: 'Salvează',
        onClick: () => {
          this.onSave();
        },
      },
      addCancelButtonOptions: {
        type: 'danger',
        stylingMode: 'contained',
        text: 'Închide',
        onClick: () => {
          this.onCancel();
        },
      },
      customTitleTemplate() {
        return `
          <div style="background-color: #ff2c21; font-size: 16px; float: right; height:47px; width:515px; color: white; 
          font-weight: bold;  padding: 15px; padding-right: 460px;  position: relative;  left: 30px;">
            Editare
          </div>
        `;
      },
    };
  },
  computed: {

  },
  watch: {
    TargetID: {
      immediate: true,
      handler(newVal) {
        this.createODataContext(newVal);
      },
    },
  },
  methods: {
    createODataContext(TargetID) {
      this.dsTargetPeUser = {
        store: new ODataStore({
          url: AppSetting.API_Url_ComercialOdata + 'CRM_TargetPeUser',
          key: 'ID',
          version: 4,
          fieldTypes: {
            TargetID: "Guid",
            ID: "Guid"
          },
          beforeSend: (e) => {
            e.headers = {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt'),
            };
          },
        }),
        filter: ['TargetID', '=', TargetID]
      };
      this.dsAgenti = {
        store: new ODataStore({
          url: AppSetting.API_Url_ComercialOdata + 'COM_Agenti?$select=Nume',
          key: 'Id',
          version: 4,
          beforeSend: (e) => {
            e.headers = {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt'),
            };
          },
        }),
      };
    },
    async getAgents() {
      try {
        const result = await CrmTargetPeUser.getAgenti();
        this.agenti = result.data
        console.log(this.agenti)
      } catch (err) {
        console.error(err);
      }
    },
    onAddClick() {
      this.isModalVisible = true;
    },
    onSave() {
      this.formData.TargetID = this.TargetID;
      if (!this.formData.Utilizator || this.formData.Utilizator.trim() === '') {
        notify('Completați câmpul obligatoriu "Utilizator"!', 'error', 1000);
        return;
      }
      if (!this.formData.Target) {
        notify('Completați câmpul obligatoriu "Target"!', 'error', 1000);
        return;
      }
      const savePromise = this.$refs.dataGridPeUserRef?.instance?.saveEditData();
      console.log(this.formData);
      const body = this.formData;
      CrmTargetPeUser.save(body).then((response) => {
        this.isModalVisible = false;
        notify('Datele au fost salvate cu succes!', 'success', 1000);
        this.formData = {

          Utilizator: '',
          Target: '',
        };
      }).catch((error) => {
        console.error(error);
        notify('Datele există deja!', 'error', 1000);
      });
    },
    onCancel() {
      this.isModalVisible = false;
    },
    setDeleteConfirmationMessage() {
      const dataGrid = this.$refs.dataGridPeUserRef?.instance;
      dataGrid.option('editing', {
        allowUpdating: true,
        allowDeleting: true,
        mode: 'popup',
        texts: {
          confirmDeleteMessage: this.deleteConfirmationMessage,
          confirmDeleteTitle: "Confirmare Ștergere",
        }
      });
    },
    onClick() {
      this.isModalVisible = true;
      //this.getAgents()
    },
    onColumnChooserClick() {
      const dataGrid = this.$refs.dataGrid.instance;
      dataGrid.showColumnChooser();
    },
    onRefreshClick() {
      this.createODataContext(this.TargetID);
      notify('Datele au fost actualizate cu succes!', 'success', 1000)
    },
    onSaveEdit() {
      // const savePromise = this.$refs.dataGridPeUserRef?.instance?.saveEditData();
      // savePromise.then((result) => {
      //   this.dataGridPeUserRef?.instance?.saveEditData();
      //   notify('Datele au fost actualizate cu succes!','success', 1000)
      // }).catch((error) => {
      //   console.error(error);
      // });
      this.dataGridPeUserRef?.instance?.saveEditData()
    },
    onCancelEdit() {
      this.dataGridPeUserRef?.instance?.cancelEditData();
    },
    onRowRemoving(e: any) {
      e.cancel = new Promise((resolve) => {
        this.dataGridPeUserRef?.instance?.saveEditData();
        notify('Datele au fost șterse cu succes!', 'success', 1000);
        resolve(false);
      });
    },
    onRowInserting() {
      notify('Datele au fost adăugate cu succes!', 'success', 1000)
    },
  },
  mounted() {
    this.createODataContext();
    this.dataGridPeUserRef = this.$refs.dataGridPeUserRef as DxDataGrid;
    this.setDeleteConfirmationMessage();
    loadMessages({
      "ro": {
        "Yes": "Da",
        "No": "Nu",
      }
    });
    locale('ro');
  },
});
</script>
<style scoped>
.border {
  border-radius: 8px;
}
</style>